import { type RedlineTextProposal, redlineTextProposalSchema } from "@common/utils/redline/wire/redline-payload";

import type { NewParagraphCardContent } from "../proposal-card/card-content";

const NUMBERED_PARAGRAPH_MARKUP = /<w:numPr\b/;

interface NewParagraphCardContentWithAnchorText extends NewParagraphCardContent {
    precedingParagraphText: string;
}

function readsAsNewParagraphs(content: NewParagraphCardContent): content is NewParagraphCardContentWithAnchorText {
    return content.newParagraphTexts.length > 0 && content.precedingParagraphText !== null;
}

export function newParagraphCardIsEditable(content: NewParagraphCardContent): boolean {
    return content.textRedline !== null || readsAsNewParagraphs(content);
}

export function textCardOfNewParagraphCard(content: NewParagraphCardContent, author: string): RedlineTextProposal | null {
    if (content.textRedline !== null) return content.textRedline;
    if (!readsAsNewParagraphs(content)) return null;
    const list = NUMBERED_PARAGRAPH_MARKUP.test(content.markup ?? "") ? "continue" : "none";
    return redlineTextProposalSchema.parse({
        author,
        cardKind: "paragraphs",
        paragraphs: [{ bookmark: content.precedingParagraphBookmark, textWhenProposed: content.precedingParagraphText, textProposed: content.precedingParagraphText }],
        insertions: content.newParagraphTexts.map((textProposed) => ({ afterBookmark: content.precedingParagraphBookmark, textProposed, list })),
        tableChanges: { rowInsertions: [], rowDeletions: [], tableInsertions: [] },
    });
}
